import ApiService from '@/api';
import { NamespaceModel } from '../../project-namespaces-page/models';
import { ResponseModel } from '@/models';

/**Сервис для вызова api */
export class NamespaceAdapterService {
  /**Api сервис */
  api = new ApiService();

  /**Получение рабочей области */
  getNamespace(namespaceId: string) {
    return new Promise<ResponseModel<NamespaceModel>>((resolve) => {
      const result = new ResponseModel<NamespaceModel>();
      this.api.Main.ProjectNamespaceService.getNamespaceByIdAsync({
        NamespaceId: namespaceId,
      })
        .then((response) => {
          result.Value = new NamespaceModel({
            Id: response.NamespaceId,
            Name: response.Name,
            IconId: response.IconId,
            IconUrl: response.IconUrl,
            ColorId: response.ColorId,
            Color: response.Color,
          });
          resolve(result);
        })
        .catch((error) => {
          console.error('Error ProjectNamespaceService.getNamespaceById', error);
          result.IsSuccess = false;
          result.ErrorCode = error.ErrorCode;
          resolve(result);
        });
    });
  }
}
